import React from "react";
import { Button, Row, Col, Container } from "reactstrap";
import { Modal } from "react-bootstrap";
import moment from "moment";
import Loading from "../../../loader/loader.js";
import { getUserRoleName } from "../../../azureLogin/authUtility.js";

const TransactionModal = (props) => {
  const roleName = getUserRoleName()
  let isSuperAdmin = roleName === "SuperAdmin";
  const disableHandler = () => {
    if (
      props.btnLoader.reverseLoading === true ||
      !props.transactionDetails.c3Ref ||
      ["REVERSED", "PENDINGREVERSE", "NEEDSMANUALREVERSAL"].includes(
        props.transactionDetails.status
      )
    ) {
      return true;
    } else {
      return false;
    }
  };

  const disableSuccessHandler = () => {
    if (
      props.btnLoader.markSuccessLoading === true ||
      !props.transactionDetails.c3Ref ||
      [
        "REVERSED",
        "PENDINGREVERSE",
        "NEEDSMANUALREVERSAL",
        "SUCCESSFUL",
      ].includes(props.transactionDetails.status)
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      className="rakTransactionModal"
      centered
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ marginBottom: 25 }}>
          <h1 style={{ paddingBottom: "25px" }}>Transactions Details</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginBottom: 10 }}>
          <Modal.Body>
            <Container className="mt--6" fluid style={{ paddingTop: "15px" }}>
              <Row className="card-wrapper" style={{ display: "flex" }}>
                <Col lg="6">
                  <h2 className="headerpadding">Receiver</h2>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Name
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {" "}
                      {props.transactionDetails &&
                        props.transactionDetails.beneficiaryDetails &&
                        props.transactionDetails.beneficiaryDetails
                          .firstName}{" "}
                      {props.transactionDetails &&
                        props.transactionDetails.beneficiaryDetails &&
                        props.transactionDetails.beneficiaryDetails
                          .middleName}{" "}
                      {props.transactionDetails &&
                        props.transactionDetails.beneficiaryDetails &&
                        props.transactionDetails.beneficiaryDetails.lastName}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Country
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.beneficiaryDetails &&
                        props.transactionDetails.beneficiaryDetails.countryName}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Type
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.transferMethod}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Bank Name
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.bankDetails &&
                        props.transactionDetails.bankDetails.bankName}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Account Number
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.bankDetails &&
                        props.transactionDetails.bankDetails.accountNumber}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      IFSC/IBAN
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.bankDetails &&
                        props.transactionDetails.bankDetails.bankCode}
                    </Col>
                  </Row>
                  <h2 className="headerpadding">Sender</h2>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Name
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.sender &&
                        props.transactionDetails.sender.name}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Country
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.sender &&
                        props.transactionDetails.sender.country}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Mobile Number
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.allUsersObject.phoneNumber}
                      {/* {props.transactionDetails &&
                        props.transactionDetails.sender &&
                        props.transactionDetails.sender.mobileNumber} */}
                    </Col>
                  </Row>
                </Col>
                <Col lg="6">
                  <h2 className="headerpadding">Transaction</h2>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Date
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {moment(
                        props.transactionDetails &&
                          props.transactionDetails.dateSent
                      ).format("DD-MM-YY")}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Sent({" "}
                      {props.transactionDetails &&
                        props.transactionDetails.sendAmount &&
                        props.transactionDetails.sendAmount.currency}
                      )
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.sendAmount &&
                        props.transactionDetails.sendAmount.amount}{" "}
                      {props.transactionDetails &&
                        props.transactionDetails.sendAmount &&
                        props.transactionDetails.sendAmount.currency}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      FxRate
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.conversionRate}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Transaction Fees({" "}
                      {props.transactionDetails &&
                        props.transactionDetails.fee.currency}
                      )
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.fee &&
                        props.transactionDetails.fee.amount}{" "}
                      {props.transactionDetails &&
                        props.transactionDetails.fee &&
                        props.transactionDetails.fee.currency}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Waived({" "}
                      {props.transactionDetails &&
                        props.transactionDetails.waivedCharge &&
                        props.transactionDetails.waivedCharge.currency}
                      )
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.waivedCharge &&
                        props.transactionDetails.waivedCharge.amount}{" "}
                      {props.transactionDetails &&
                        props.transactionDetails.waivedCharge &&
                        props.transactionDetails.waivedCharge.currency}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Debited({" "}
                      {props.transactionDetails &&
                        props.transactionDetails.debitCurrency &&
                        props.transactionDetails.debitCurrency.currency}
                      )
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {/* {props.transactionDetails &&
                        props.transactionDetails.debitCurrency &&
                        props.transactionDetails.debitCurrency.amount}{" "} */}
                      {parseFloat(
                        props.transactionDetails &&
                          props.transactionDetails.sendAmount &&
                          props.transactionDetails.sendAmount.amount
                      ) +
                        parseFloat(
                          props.transactionDetails &&
                            props.transactionDetails.fee &&
                            props.transactionDetails.fee.amount
                        )}{" "}
                      {props.transactionDetails &&
                        props.transactionDetails.debitCurrency &&
                        props.transactionDetails.debitCurrency.currency}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Received
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.receiveAmount.currency}
                      ({" "}
                      {props.transactionDetails &&
                        props.transactionDetails.receiveAmount.amount}
                      )
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Purpose
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.moneyTransferPurpose}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      C3 Ref
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.c3Ref}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      RAK Ref
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {/* {props.transactionDetails &&
                        props.transactionDetails.rakRef} */}
                      {props.transactionDetails &&
                      props.transactionDetails.rakRef ===
                        "00000000-0000-0000-0000-000000000000"
                        ? "N/A"
                        : props.transactionDetails &&
                          props.transactionDetails.rakRef}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Status
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      <div>
                        {props.transactionDetails &&
                          props.transactionDetails.status}
                      </div>
                      <div>
                        <Button
                          color="primary"
                          onClick={props.updateStatusClicked}
                          disabled={props.updateloading === true ? true : false}
                        >
                          {props.updateloading ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100px",
                              }}
                            >
                              <Loading
                                color="white"
                                width="20px"
                                height="20px"
                              />
                            </div>
                          ) : (
                            "Update status"
                          )}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Status Reason
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.remarks}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Referrer Code
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.referralCode}
                    </Col>
                  </Row>
                  {isSuperAdmin ? (
                    <Row style={{ paddingTop: "15px" }}>
                      <Col lg="6">
                        <Button
                          color="primary"
                          onClick={() =>
                            props.reverseClickHandler(
                              props.transactionDetails.c3Ref
                            )
                          }
                          disabled={disableHandler()}
                        >
                          {props.btnLoader.reverseLoading ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100px",
                              }}
                            >
                              <Loading
                                color="white"
                                width="20px"
                                height="20px"
                              />
                            </div>
                          ) : (
                            "Reverse"
                          )}
                        </Button>
                      </Col>
                      <Col lg="6">
                        <Button
                          color="primary"
                          onClick={() =>
                            props.markSuccessClickHandler(
                              props.transactionDetails.c3Ref
                            )
                          }
                          disabled={disableSuccessHandler()}
                        >
                          {props.btnLoader.markSuccessLoading ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100px",
                              }}
                            >
                              <Loading
                                color="white"
                                width="20px"
                                height="20px"
                              />
                            </div>
                          ) : (
                            "Mark as Success"
                          )}
                        </Button>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
            </Container>
          </Modal.Body>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default TransactionModal;
